module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "extras"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_vm._l((_vm.concessionsFiltered), function(group, index) {
    return (group.Name != 'PromoCombos' && group.Name != 'Subs') ? _c('sk-accordian', {
      key: index,
      ref: "acorn",
      refInFor: true,
      attrs: {
        "active": _vm.isActive(index)
      }
    }, [_c('template', {
      slot: "header"
    }, [(group.Name === 'Combos') ? _c('h2', [_vm._v("Choose Snacks")]) : _vm._e(), _vm._v(" "), (group.Name === '3D Glasses') ? _c('h2', [_vm._v("Add 3D Glasses")]) : _vm._e(), _vm._v(" "), (group.Name === 'Imax 3D Gl') ? _c('h2', [_vm._v("Add 3D IMAX Glasses")]) : _vm._e(), _vm._v(" "), (group.Name === 'Donations') ? _c('h2', [_vm._v("Donate to Vision Mission")]) : _vm._e()]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [(group.Name !== 'Donations') ? [_c('sk-panel', [(group.Name == '3D Glasses') ? [_c('p', [_vm._v("\n                Please choose the type of 3D glasses you need and how many.\n              ")])] : _vm._e(), _vm._v(" "), (group.Name == 'Combos') ? [_c('div', {
      staticClass: "covid-message"
    }, [_c('sk-layout', {
      staticClass: "covid-wrapper",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('sk-panel', {
      staticClass: "covid-panel"
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      staticClass: "covid-icon-container",
      attrs: {
        "lg1": "",
        "md2": "",
        "sm2": "",
        "xs3": ""
      }
    }, [_c('div', {
      staticClass: "icon icon-combo"
    })]), _vm._v(" "), _c('sk-flex', {
      staticClass: "covid-message-container",
      attrs: {
        "lg11": "",
        "md10": "",
        "sm10": "",
        "xs9": ""
      }
    }, [_c('p', [(_vm.order != undefined || _vm.order != null) ? [_c('strong', [_vm._v("What's a movie without popcorn? Can't decide\n                                which snacks to buy online now? Don't fret!\n                                Snacks can now be purchased in the\n                                cinema.")]), _c('br'), _vm._v("\n                              Sweet and drink options are subject to\n                              availability\n                            ")] : _vm._e()], 2)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })], 1)], 1)] : _vm._e(), _vm._v(" "), (group.Name == 'Donations') ? [_c('p', [_c('strong', [_vm._v("Donate to Vision Mission now by adding R2.50 or more to\n                  your ticket price.")])]), _vm._v(" "), _c('p', [_vm._v("\n                Vision Mission is a Ster-Kinekor initiative which helps\n                children with visual impairments by improving their vision, so\n                that they can enjoy movies too.\n              ")])] : _vm._e(), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((group.ConcessionItems), function(concession) {
      return (
        (concession.isRelatedPromo || concession.movie ?
          true :
          false) && concession.PriceInCents > 0
      ) ? _c('sk-flex', {
        key: concession.Id,
        attrs: {
          "xs6": "",
          "md4": "",
          "lg3": ""
        }
      }, [_vm._v("\n                " + _vm._s(concession.quantity) + "\n                "), _c('sk-counter-box', {
        attrs: {
          "concession": concession,
          "type": concession.ItemClassCode
        },
        on: {
          "concessionChange": _vm.setConcession
        },
        model: {
          value: (concession.quantity),
          callback: function($$v) {
            _vm.$set(concession, "quantity", $$v)
          },
          expression: "concession.quantity"
        }
      })], 1) : _vm._e()
    })), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((group.ConcessionItems), function(concession) {
      return (!concession.isRelatedPromo &&
        (concession.movie ? false : true) &&
        concession.Description != 'DONATION R100' &&
        concession.Description != 'DONATION R200' &&
        concession.Description != 'DONATION R250' &&
        concession.Description != 'DONATION R2500' &&
        concession.Description != 'DONATION R300' &&
        concession.Description != 'DONATION R5000' &&
        concession.Description != 'DONATION R750' &&
        concession.Description != 'DONATION R500' &&
        concession.PriceInCents > 0
      ) ? _c('sk-flex', {
        key: concession.Id,
        attrs: {
          "xs6": "",
          "md4": "",
          "lg3": ""
        }
      }, [_c('sk-counter-box', {
        attrs: {
          "concession": concession,
          "type": concession.ItemClassCode,
          "altStyle": true
        },
        on: {
          "concessionChange": _vm.setConcession
        },
        model: {
          value: (concession.quantity),
          callback: function($$v) {
            _vm.$set(concession, "quantity", $$v)
          },
          expression: "concession.quantity"
        }
      }, [_c('template', {
        slot: "icon"
      }, [_c('div', {
        staticClass: "counter-box__icon"
      }, [_c('img', {
        staticStyle: {
          "position": "absolute",
          "left": "0",
          "top": "0",
          "width": "100%"
        },
        attrs: {
          "src": 'https://movies.sterkinekor.co.za/CDN/media/entity/get/ItemGraphic/' +
            concession.Id,
          "alt": concession.Name
        }
      })])])], 2)], 1) : _vm._e()
    })), _vm._v(" "), (group.Name == 'Combos' && _vm.rewards.length > 0) ? _c('sk-panel', {
      staticClass: "extras-points"
    }, [_c('h5', [_vm._v("Your Available Rewards")]), _vm._v(" "), _c('p', [_vm._v("\n                You Have " + _vm._s(_vm.rewards.length) + " Available Free COMBO" + _vm._s((_vm.rewards.length > 1 && "s") || "") + ". You can use\n                " + _vm._s((_vm.rewards.length > 1 && "them") || "it") + " now or save\n                " + _vm._s((_vm.rewards.length > 1 && "them") || "it") + " for later.\n              ")]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": ""
      }
    }, _vm._l((_vm.rewards), function(reward) {
      return _c('sk-flex', {
        key: reward.VistaID,
        attrs: {
          "grow": ""
        }
      }, [_c('hr'), _vm._v(" "), _c('sk-checkbox', {
        staticClass: "linked-combo",
        attrs: {
          "label": "I'd rather not say"
        },
        on: {
          "input": function($event) {
            _vm.applyReward(reward.linked, reward)
          }
        },
        model: {
          value: (reward.linked),
          callback: function($$v) {
            _vm.$set(reward, "linked", $$v)
          },
          expression: "reward.linked"
        }
      }, [_c('div', {
        staticClass: "linked-combo__description",
        attrs: {
          "slot": "label"
        },
        slot: "label"
      }, [_c('sk-badge', {
        attrs: {
          "small": "",
          "no-backface": "",
          "color": reward.badge.color
        }
      }, [_c('template', {
        slot: "front"
      }, [_c('sk-icon', {
        attrs: {
          "icon": reward.badge.icon
        }
      })], 1), _vm._v(" "), _c('template', {
        slot: "back"
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "linked-combo__card-content btn-mask"
      }, [_c('div', {
        staticClass: "linked-combo__club-cards-title"
      }, [_vm._v("\n                          " + _vm._s(reward.badge.description) + "\n                        ")]), _vm._v(" "), _c('p', {
        staticClass: "linked-combo__club-cards-copy"
      }, [_vm._v("\n                          " + _vm._s(reward.badge.title) + "\n                        ")])])], 1)])], 1)
    }))], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": "/booking/1"
      }
    }, [_vm._v("Back")]), _vm._v(" "), _c('sk-spacer'), _vm._v(" "), _c('sk-button', {
      attrs: {
        "primary": "",
        "loading": _vm.loadingUpdateOrder
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.nextConsession(group, index)
        }
      }
    }, [(group.Name === 'Imax 3D Gl') ? [_vm._v("Continue")] : _vm._e(), _vm._v(" "), (group.Name === '3D Glasses') ? [_vm._v("Continue")] : _vm._e(), _vm._v(" "), (group.Name === 'Combos') ? [_vm._v("Continue")] : _vm._e(), _vm._v(" "), (group.Name === 'Donations') ? [_vm._v("Continue")] : _vm._e()], 2)], 1)], 2)] : _vm._e(), _vm._v(" "), (group.Name === 'Donations') ? [_c('sk-panel', [_c('sk-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "sm9": "",
        "xs9": ""
      }
    }, [_c('p', [_vm._v("Help Kids See the Magic of Movies.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                    Add just R2.50 to your ticket and make a difference with\n                    Vision Mission.\n                  ")])]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((group.ConcessionItems), function(concession) {
      return (!concession.isRelatedPromo &&
        concession.Description == 'DONATION R2.50' &&
        concession.PriceInCents > 0
      ) ? _c('sk-flex', {
        key: concession.Id,
        attrs: {
          "xs12": "",
          "md6": "",
          "lg4": ""
        }
      }, [_c('sk-counter-box', {
        attrs: {
          "smallCounter": "",
          "showRandValue": "",
          "concession": concession,
          "type": concession.ItemClassCode
        },
        on: {
          "concessionChange": _vm.setConcession
        },
        model: {
          value: (concession.quantity),
          callback: function($$v) {
            _vm.$set(concession, "quantity", $$v)
          },
          expression: "concession.quantity"
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin": "12px 12px 12px 50%",
          "text-indent": "-9px"
        }
      }, [_vm._v("\n                      OR\n                    ")]), _vm._v(" "), _c('sk-button', {
        attrs: {
          "tertiary": "",
          "loading": _vm.loadingUpdateOrder
        },
        nativeOn: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.setDonateAndCheckout(concession, 2, group, index)
          }
        }
      }, [
        [_vm._v("Donate R5 and Checkout")]
      ], 2)], 1) : _vm._e()
    })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("ABOUT VISION MISSION")]), _vm._v(" "), _c('h5', [_vm._v("Brighter Futures Through Clear Vision")]), _vm._v(" "), _c('p', [_vm._v("\n                  In South Africa, millions of children struggle with vision\n                  impairment. Most of these conditions are treatable, but many\n                  underprivileged kids lack access to affordable care."), _c('br'), _vm._v("\n                  We believe every child deserves to see the world clearly. As\n                  movie enthusiasts, we understand the power of sight in\n                  creating memorable experiences. That’s why we're dedicated\n                  to improving their vision, so they can enjoy Great Moments\n                  with movies too.\n                ")])], 1), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "sm3": "",
        "xs3": ""
      }
    }, [_c('div', {}, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/vision_mission.png"
      }
    })])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": "/booking/1"
      }
    }, [_vm._v("Back")]), _vm._v(" "), _c('sk-spacer'), _vm._v(" "), _c('sk-button', {
      attrs: {
        "primary": "",
        "loading": _vm.loadingUpdateOrder
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.nextConsession(group, index)
        }
      }
    }, [
      [_vm._v("Continue to Checkout")]
    ], 2)], 1)], 1)] : _vm._e()], 2)], 2) : _vm._e()
  }), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": _vm.$breakpoints.xs ? true : false,
      "overlay": true
    },
    model: {
      value: (_vm.glassesDialog),
      callback: function($$v) {
        _vm.glassesDialog = $$v
      },
      expression: "glassesDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.glassesDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.glassesDialog = false
      }
    }
  }), _vm._v(" "), (_vm.order.CinemaId == '6171' && _vm.experience == '3D IMAX') ? [_c('h3', [_vm._v("THIS IS AN IMAX® WITH LASER 3D MOVIE")]), _vm._v(" "), _c('p', [_vm._v("\n          This cinema is equipped with new laser technology and requires\n          state-of-the-art 3D glasses. Kindly note that regular IMAX glasses\n          are not compatible with the new IMAX Laser system.\n        ")])] : [_c('h3', [_vm._v("This is a 3D Movie")]), _vm._v(" "), _c('p', [_vm._v("\n          3D glasses will ensure you enjoy the best experience! Things will\n          get pretty blurry without them.\n        ")])], _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.glassesDialog = false
      }
    }
  }, [_vm._v("Wait, go back")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.loadingUpdateOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.nextAccordionIndex(_vm.currentConcession)
      }
    }
  }, [_vm._v("\n        Yes, I'm sure\n      ")])], 2), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": _vm.$breakpoints.xs ? true : false,
      "overlay": true
    },
    model: {
      value: (_vm.donationDialog),
      callback: function($$v) {
        _vm.donationDialog = $$v
      },
      expression: "donationDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.donationDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.donationDialog = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Looks like you missed the Vision Mission Donation")]), _vm._v(" "), _c('p', [_vm._v("Help visually impaired children by adding R2.50 to your booking.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.donationDialog = false
      }
    }
  }, [_vm._v("Donate")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.loadingUpdateOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.nextAccordionIndex(_vm.currentConcession)
      }
    }
  }, [_vm._v("\n        No, thanks\n      ")])], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-523e9fb4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/extras/extras.vue
// module id = 734
// module chunks = 0